import api from './api';

const widgetsService = {
  // Enabled widgets for the current user's org, already in rail order.
  getWidgets: async () => {
    const response = await api.get('/api/v1/widgets');
    return response.data;
  },

  adminListWidgets: async () => {
    const response = await api.get('/api/v1/admin/widgets');
    return response.data;
  },

  // Partial update: send only the fields you're changing. Config merges
  // server-side (one level deep), so a single weight can be patched without
  // resending the whole blob.
  adminUpdateWidget: async (key, payload) => {
    const response = await api.patch(`/api/v1/admin/widgets/${key}`, payload);
    return response.data;
  },

  adminReorderWidgets: async (order) => {
    const response = await api.put('/api/v1/admin/widgets/order', { order });
    return response.data;
  },
};

export default widgetsService;
